var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PPage',[_c('EditContainer',{attrs:{"cv":_vm.$store.getters['cv_design/cv'],"cv-design-template-samples":_vm.$store.getters['cv_design/cvDesignTemplateSamples']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }